// utils
import apiSlice from "src/utils/api-slice";

// ----------------------------------------------------------------------

const API_ENDPOINTS = {
    getTotalSaving: "/shipment/report/total_saving",
    getAveragePrice: "/shipment/report/avg_price",
    getBalance: "/transaction/wallet/info",
    //
    getAnalysis: "/shipment/report/analysis_by_time"
};

// ----------------------------------------------------------------------

const {
    useGetTotalSavingQuery,
    useGetAveragePriceQuery,
    useGetBalanceQuery,
    //
    useGetAnalysisQuery
} = apiSlice.injectEndpoints({
    endpoints: builder => ( {
        getTotalSaving: builder.query({
            keepUnusedDataFor: 5,
            providesTags: ["ReportTotalSaving"],
            query: () => `${API_ENDPOINTS.getTotalSaving}`,
            transformResponse: ({ data }, meta, arg) => data
        }),
        getAveragePrice: builder.query({
            keepUnusedDataFor: 5,
            providesTags: ["ReportAveragePrice"],
            query: () => `${API_ENDPOINTS.getAveragePrice}`,
            transformResponse: ({ data }, meta, arg) => data
        }),
        getBalance: builder.query({
            keepUnusedDataFor: 5,
            providesTags: ["ReportBalance"],
            query: () => `${API_ENDPOINTS.getBalance}`,
            transformResponse: ({ data }, meta, arg) => data
        }),
        getAnalysis: builder.query({
            keepUnusedDataFor: 5,
            providesTags: ["ReportAnalysis"],
            query: ({ date_range }) => `${API_ENDPOINTS.getAnalysis}?date_range=${date_range}`,
            transformResponse: ({ data }, meta, arg) => data
        })
    } ),
    overrideExisting: true
});

// ----------------------------------------------------------------------

export {
    useGetTotalSavingQuery,
    useGetAveragePriceQuery,
    useGetBalanceQuery,
    //
    useGetAnalysisQuery
};